// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pauseButtonContainer {
   width: 100px;
   height: 40px;
   border: solid var(--text-primary) 1px;
   text-align: center;
   position: relative;
    margin-left: auto;
    margin-right: auto;
    transition: border-color 0.3s;
 }

.pauseButtonContainer:hover {
  border: solid var(--text-primary) 2px;
}

.play {

}

.pauseButtonContainer > .icon {
    color: var(--text-primary);
    font-size: 25px;
    height: 100%;
    transition: color 0.3s;
}
.pauseButton{
  text-align-all: center;
}
.pause {
  margin: auto;
  width: 0;
  height: 30px;
  border-color: var(--text-secondary);
  border-style: double;
  border-width: 0px 0px 0px 25px;
  transition: border-color 0.3s;
}

.play {
  margin: auto;
  width: 0;
  height: 50%;
  border-style: solid;
  box-sizing: border-box;
  border-width: 15px 0px 15px 25px;
  border-color: transparent transparent transparent var(--text-primary);
  transition: border-color 0.3s;
}

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}
`, "",{"version":3,"sources":["webpack://./src/components/PauseButton.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,YAAY;GACZ,qCAAqC;GACrC,kBAAkB;GAClB,kBAAkB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;CAChC;;AAED;EACE,qCAAqC;AACvC;;AAEA;;AAEA;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,mCAAmC;EACnC,oBAAoB;EACpB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,qEAAqE;EACrE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,gCAAgC;AAClC","sourcesContent":[".pauseButtonContainer {\n   width: 100px;\n   height: 40px;\n   border: solid var(--text-primary) 1px;\n   text-align: center;\n   position: relative;\n    margin-left: auto;\n    margin-right: auto;\n    transition: border-color 0.3s;\n }\n\n.pauseButtonContainer:hover {\n  border: solid var(--text-primary) 2px;\n}\n\n.play {\n\n}\n\n.pauseButtonContainer > .icon {\n    color: var(--text-primary);\n    font-size: 25px;\n    height: 100%;\n    transition: color 0.3s;\n}\n.pauseButton{\n  text-align-all: center;\n}\n.pause {\n  margin: auto;\n  width: 0;\n  height: 30px;\n  border-color: var(--text-secondary);\n  border-style: double;\n  border-width: 0px 0px 0px 25px;\n  transition: border-color 0.3s;\n}\n\n.play {\n  margin: auto;\n  width: 0;\n  height: 50%;\n  border-style: solid;\n  box-sizing: border-box;\n  border-width: 15px 0px 15px 25px;\n  border-color: transparent transparent transparent var(--text-primary);\n  transition: border-color 0.3s;\n}\n\n.centered {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  /* bring your own prefixes */\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
